if (!customElements.get('hanmade-cafe-menu')) {
  customElements.define('hanmade-cafe-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const links = [...this.querySelectorAll('[data-location]')];
      const panels = [...this.querySelectorAll('[data-location-panel]')];
      const select = (id, focus = false) => {
        const selected = panels.find(panel => panel.id === id);
        panels.forEach(panel => { panel.hidden = panel !== selected; });
        links.forEach(link => {
          if (link.dataset.location === id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        this.querySelector('[data-location-prompt]').hidden = Boolean(selected);
        if (focus && selected) selected.focus({ preventScroll: true });
      };
      links.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const id = link.dataset.location;
        if (location.hash !== '#' + id) history.pushState(null, '', '#' + id);
        select(id, true);
      }, options));
      window.addEventListener('hashchange', () => select(location.hash.slice(1)), options);
      window.addEventListener('popstate', () => select(location.hash.slice(1)), options);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-location-panel]');
        if (panel) select(panel.id);
      }, options);
      select(location.hash.slice(1));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
